import { HorizontalColoredListItemsCell } from "app/components/React/Table/cells/HorizontalColoredListItemsCell";
import { PlainTooltip } from "app/components/React/Tooltip/PlainTooltip/PlainTooltip";
import type { FunctionComponent } from "react";
import type { IListItem } from "app/components/React/Table/cells/DomainListWithTooltip/types";
import { ListItemsTooltip } from "./ListItemsTooltip";

interface IDomainListWithTooltipProps {
    value: IListItem[];
}
export const DomainListWithTooltip: FunctionComponent<IDomainListWithTooltipProps> = (props) => {
    const { value } = props;
    const tooltipProps = {
        text: <ListItemsTooltip listItems={value} />,
        cssClass: "domain-list-with-tooltip",
        cssClassContent: "domain-list-with-tooltip-content",
    };
    return (
        <PlainTooltip {...tooltipProps}>
            <div>
                <HorizontalColoredListItemsCell {...props} />
            </div>
        </PlainTooltip>
    );
};
